// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___FdxX6";
export var content = "styles-module__content___CVCBU";
export var left = "styles-module__left___nwMiK";
export var right = "styles-module__right___pRpXE";
export var widget = "styles-module__widget___objzh";
export var contentWidget = "styles-module__contentWidget___mJbFM";
export var widgetTitle = "styles-module__widgetTitle___q1w1Z";
export var summaryMetrics = "styles-module__summaryMetrics___ecFa6";
export var summaryMetric = "styles-module__summaryMetric___mrrzH";
export var summaryMetricTitle = "styles-module__summaryMetricTitle___Ghgkd";
export var summaryMetricValue = "styles-module__summaryMetricValue___Yp5Ef";
export var summaryMetricValueChange = "styles-module__summaryMetricValueChange___Oqmm7";
export var negative = "styles-module__negative___tTuCw";
export var positive = "styles-module__positive___Mdv7G";